import React, { Fragment } from "react";
import PropTypes from "prop-types";
import "./RatingScale.scss";

const RatingScale = ({
  min,
  max,
  value,
  onChange,
  minLabel,
  maxLabel,
  disabled,
}) => {
  const ratings = [];
  for (let i = min; i <= max; i += 1) {
    ratings.push(i);
  }

  const handleClick = rating => {
    if (!disabled) {
      onChange(rating);
    }
  };

  const handleKeyDown = (e, rating) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleClick(rating);
    }
  };

  return (
    <div className="rating-scale">
      <div className="rating-scale__container">
        {ratings.map(rating => (
          <Fragment key={rating}>
            <button
              type="button"
              className={`rating-scale__item ${
                value === rating ? "rating-scale__item--selected" : ""
              } ${disabled ? "rating-scale__item--disabled" : ""}`}
              onClick={() => handleClick(rating)}
              onKeyDown={e => handleKeyDown(e, rating)}
              disabled={disabled}
              aria-label={`Rating ${rating}`}
              aria-pressed={value === rating}
            >
              {rating}
              {rating === 1 && (
                <span className="rating-scale__label rating-scale__label--min">
                  {minLabel}
                </span>
              )}
              {rating === max && (
                <span className="rating-scale__label rating-scale__label--max">
                  {maxLabel}
                </span>
              )}
            </button>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

RatingScale.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  minLabel: PropTypes.string,
  maxLabel: PropTypes.string,
  disabled: PropTypes.bool,
};

RatingScale.defaultProps = {
  min: 1,
  max: 10,
  value: null,
  minLabel: "",
  maxLabel: "",
  disabled: false,
};

export default RatingScale;
